import { type ErrorResponse } from 'react-router-dom';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { type BffCancelStorageDeclarationRequest } from '../../../../generated/api-client';
import { type NetworkResponse, put } from '../../../../network/apis/utils';
import { bffServiceUrl } from '../../../../network/netconfig';

export const useCancelDeclaration = (
  options?: UseMutationOptions<
    NetworkResponse<{ status: number }>,
    ErrorResponse,
    BffCancelStorageDeclarationRequest & { declarationId: string }
  >,
) => {
  return useMutation({
    mutationFn: ({ declarationId, ...body }) => {
      return put(
        `${bffServiceUrl}/bff-storage-declarations/storage-locations/storage-declarations/${declarationId}/cancel`,
        body,
      );
    },
    ...options,
  });
};
